export default "__VITE_ASSET__D4au1ahu__"